module.exports = __webpack_public_path__ + "static/media/DSCF1339-2-2.920c155c.jpg";